// eslint-disable-next-line
import React from "react";

export function Identity({ children }) {
  return <>{children}</>;
}
